import { FC } from 'react';
import styles from './index.module.less';
import ScoreExplaimIcon from '@/common/components/business/AreaScoreWithoutSum/ScoreExplaimIcon';
import FourNoSumPredictSale from '@/common/components/business/AreaScoreWithoutSum/FourNoSumPredictSale';
import { Col, Row } from 'antd';
import ScoreCard from '../ScoreCard';

/**
 * @Description 四维无总分-商圈详情
 */
const FourNoSumCon:FC<{
  overViewData: any;
  predictSale: any;
  cardView: any;
  isSemirModel?: boolean;
}> = ({
  overViewData,
  predictSale,
  cardView,
  isSemirModel = false,
}) => {
  return (
    <div className={styles.fourNoSumCon}>
      <div className={styles.title}>
        四维评分
        {
          isSemirModel ? <></>
            : <ScoreExplaimIcon data={overViewData} predictSale={predictSale} className={styles.titleIcon}/>
        }
      </div>
      {predictSale ? <FourNoSumPredictSale data={overViewData} className={styles.predictSale}/> : <></>}
      <div className={styles.cardView}>
        <Row gutter={[24, 14]}>
          {cardView.length ? cardView.map((item, index: number) => (
            <Col span={12} key={item?.name}>
              <ScoreCard
                title={item?.name}
                score={item?.score}
                totalScore={item?.score}
                describe={item?.msg}
                lineColor='#5B9FFF'
                lineBgColor='#FFFFFF'
                // 森马模型的维度中有四个字/五个字的区别， 为了展示美观
                hasBlank={isSemirModel && (index === 1 || index === 3)}
                isSemirModel={isSemirModel}
              />
            </Col>
          )) : <></>}
        </Row>
      </div>
    </div>
  );
};

export default FourNoSumCon;
